import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Divider from "../../components/layout/Divider";
import Modal from "../../components/Modal";
import { Roles } from "../../components/roles";
import { Link } from "react-router-dom";

function BookingSignOutSuccess(props: any) {
  const { t } = useTranslation(); //i18n

  let url = document.URL;

  return (
    <Container className="pt-5">
      <Row>
        <Col xs={{ span: 10, offset: 1 }}>
          <Modal>
            <h1 className="text-center">{t("bookingSignOutSuccess.title")}</h1>
            <div className="text-center">
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-primary"
                size="6x"
              />
            </div>
            <Divider />
            <div className="mt-2 p-2 mlr-4 text-center">

              <p className="my-5">
                {t("bookingSignOutSuccess.labelSignOutInfo")}
              </p>
              <Link to={url.includes("terminal") ? "/terminal" : "/"}>
                <Button
                  variant="secondary"
                  className="w-80 mb-2 border mx-auto"
                >
                  {url.includes("terminal") ? t("bookingSuccessful.backToTerminal") : t("bookingSignOutSuccess.finish")}
                </Button>
              </Link>
            </div>
          </Modal>
        </Col>
      </Row>
    </Container >
  );
}

export default BookingSignOutSuccess;
